import { lang } from 'moment';
import axiosInstance from '../../src/axios'

import {
  API_BASE_URL,
  API_KEY,
  s3ApiUrl
} from '../../src/constants';
import { sendEventToFlutter } from '../components/App/FamilyTree';
import { treeFit } from './view/View.handlers';
import { callFlutterHandler } from '../FlutterHandler';
import { jsPDF } from "jspdf";
import "svg2pdf.js";
const AWS = require('aws-sdk');
const { toPng,toSvg } = require('html-to-image');


// import { v4 as uuidv4 } from 'uuid';
// Configure AWS SDK with your credentials and S3 bucket information
AWS.config.update({
  // accessKeyId: 'AKIAXUD4YKDH74GLUH5Y',
  accessKeyId: 'AKIAXUD4YKDH3RR3HBLH',
  // secretAccessKey: 'jCQbmbfNGiQ3VCI8gYf3H9qi5UiGfBzDUbwEN1Eg',
  secretAccessKey: '4Z8ry9JDj87asswwNMH1NzeRUmq9lYUKCjsm+30z',
  region: 'ap-south-1', // Replace with your desired region
});


const s3 = new AWS.S3();
const bucketName = 'prod-media-file';

  
function removeCardAddPathElements(svgData,language) {
	let clonedSvgElement = svgData.cloneNode(true);

    const addPathRemove= clonedSvgElement.querySelectorAll('g.card_add_path');

    addPathRemove.forEach(element => {
        element.parentNode.removeChild(element);
    });
	const addButtonRemove = clonedSvgElement.querySelectorAll('g.card_add_relative');

    addButtonRemove.forEach(element => {
        element.parentNode.removeChild(element);
    });

	const removeIcons = clonedSvgElement.querySelectorAll('.crossIcon.card_remove_icon');
    removeIcons.forEach(element => {
        element.parentNode.removeChild(element);
    });

	const cardOptionsRemove = clonedSvgElement.querySelectorAll('.card-options');
    cardOptionsRemove.forEach(element => {
        element.parentNode.removeChild(element);
    });
	
	const resetButtonRemove = clonedSvgElement.querySelectorAll('.reset_button');
    resetButtonRemove.forEach(element => {
        element.parentNode.removeChild(element);
    });
	
	const hideButtonRemove = clonedSvgElement.querySelectorAll('.card_hide_path');
    hideButtonRemove.forEach(element => {
        element.parentNode.removeChild(element);
    });
	
	const undoButtonRemove = clonedSvgElement.querySelectorAll('.undo_button');
    undoButtonRemove.forEach(element => {
        element.parentNode.removeChild(element);
    }); 
	// console.log(language)
	const titleElements = clonedSvgElement.querySelectorAll('tspan.title');
	// console.log(titleElements)
	const connectorElement = clonedSvgElement.querySelectorAll('.connectorLine');
    connectorElement.forEach(element => {
        element.parentNode.removeChild(element);
    });
	
    titleElements.forEach(element => {
        element.setAttribute('font-family',language && language.value?language.value:""); // Replace with your desired font-family
    });
	// console.log(clonedSvgElement)
	// clonedSvgElement=splitTextInTspans(clonedSvgElement,language)
	return clonedSvgElement;
}
async function convertImageToBase64(imageUrl) {
	try {
	  const response = await fetch(imageUrl); // Fetch the image
	  const blob = await response.blob(); // Convert the image to a Blob
  
	  const base64String = await new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => {
		  console.log("Base64 conversion done:", reader.result); // Debugging to ensure base64 is done
		  resolve(reader.result); // Resolve with Base64 string
		};
		reader.onerror = (error) => {
		  console.error("Base64 conversion failed:", error);
		  reject(error);
		};
		reader.readAsDataURL(blob); // Convert the Blob to base64
	  });
  
	  return base64String;
	} catch (error) {
	  console.error("Error fetching image:", error);
	  throw error;
	}
  }
  // Renders an SVG string onto a canvas, mimicking the old cairosvg behavior:
// - white background
// - either fixed padded size (coordinates.width/height + 500) or natural size (fit_tree)
// - scale factor for crispness (stand-in for cairosvg's scale+dpi)
function svgStringToCanvas(svgString, { coordinates, fitTree, scale = 2.5 }) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    // Ensure explicit width/height on the SVG root so the Image loads at a known intrinsic size
    const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      const targetWidth = fitTree ? img.naturalWidth : coordinates.width + 500;
      const targetHeight = fitTree ? img.naturalHeight : coordinates.height + 500;

      const canvas = document.createElement("canvas");
      canvas.width = targetWidth * scale;
      canvas.height = targetHeight * scale;

      const ctx = canvas.getContext("2d");
      // white background (cairosvg's background_color='white')
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.scale(scale, scale);
      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

      URL.revokeObjectURL(url);
      resolve(canvas);
    };

    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };

    img.src = url;
  });
}

async function svgToPng(svgString, { coordinates, fitTree }) {
  const canvas = await svgStringToCanvas(svgString, { coordinates, fitTree, scale: 2.5 });
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), "image/png");
  });
}


async function svgToPdfVector(svgElement, { coordinates, fitTree }) {
  const width = fitTree ? svgElement.getBBox().width : coordinates.width + 500;
  const height = fitTree ? svgElement.getBBox().height : coordinates.height + 500;

  const pdf = new jsPDF({
    orientation: width >= height ? "landscape" : "portrait",
    unit: "pt",
    format: [width, height],
  });
  console.log("Passing to pdf.svg():", svgElement);
console.log("tagName:", svgElement?.tagName);
console.log("has querySelectorAll:", typeof svgElement?.querySelectorAll);
console.log("ownerDocument === document:", svgElement?.ownerDocument === document);
  // svg2pdf needs a live SVG element (not a string), so pass svgElementClone directly
  await pdf.svg(svgElement, { x: 0, y: 0, width, height });
  return pdf.output("blob");
}

function downloadBlobLocally(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke after a tick so the browser has time to start the download
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
async function inlineExternalImages(svgElement) {
	console.log("inside inlineExternalImages")
  // Clone so we don't mutate the live DOM tree
  const clone = svgElement.cloneNode(true);
  const images = clone.querySelectorAll("image");

  await Promise.all(
    Array.from(images).map(async (imgEl) => {
      const href =
        imgEl.getAttribute("href") || imgEl.getAttribute("xlink:href");

      if (!href || href.startsWith("data:")) return; // already inline, skip

      try {
        const response = await fetch(href, { mode: "cors" });
        const blob = await response.blob();
        const dataUrl = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
        imgEl.setAttribute("href", dataUrl);
        imgEl.setAttribute("xlink:href", dataUrl);
      } catch (err) {
        console.error("Failed to inline image, canvas will likely be tainted:", href, err);
      }
    })
  );

  return clone;
}
function ensureXlinkNamespace(svgString) {
  if (svgString.includes("xmlns:xlink")) return svgString;
  return svgString.replace(
    "<svg ",
    '<svg xmlns:xlink="http://www.w3.org/1999/xlink" '
  );
}
function replaceForeignObjectsWithText(svgElement) {
  const clone = svgElement.cloneNode(true);
  const foreignObjects = clone.querySelectorAll("foreignObject");

  foreignObjects.forEach((fo) => {
    const x = fo.getAttribute("x") || 0;
    const y = fo.getAttribute("y") || 0;
    const width = parseFloat(fo.getAttribute("width")) || 100;
    const height = parseFloat(fo.getAttribute("height")) || 20;

    // Pull out visible text content from the HTML inside
    const textContent = fo.textContent.trim();

    const textEl = document.createElementNS("http://www.w3.org/2000/svg", "text");
    textEl.setAttribute("x", x);
    textEl.setAttribute("y", parseFloat(y) + height / 2); // rough vertical centering
    textEl.setAttribute("font-size", "14");
    textEl.setAttribute("fill", "#000");
    textEl.textContent = textContent;

    fo.parentNode.replaceChild(textEl, fo);
  });

  return clone;
}
async function handleExport(svgElementClone, exportType, coordinates, fitTree,isBefore,member_id,fileName) {
  const noForeignObjects = replaceForeignObjectsWithText(svgElementClone);
  const inlinedSvgElement = await inlineExternalImages(noForeignObjects);

  const serializer = new XMLSerializer();
  const svgString = ensureXlinkNamespace(serializer.serializeToString(inlinedSvgElement));


  let blob;
  let mimeExt;

  if (exportType === "html") {
    blob = new Blob([svgString], { type: "text/html" });
    mimeExt = "html";
  } else if (exportType === "png") {
    blob = await svgToPng(svgString, { coordinates, fitTree });
    mimeExt = "png";
  } else {
    // pdf
    blob = await svgToPdfVector(svgElementClone, { coordinates, fitTree }); // or svgToPdfVector(svgElementClone, ...)
    mimeExt = "pdf";
  }

  const base64Data = await blobToBase64(blob);
//   const fileName = `export_${Date.now()}.${mimeExt}`;
  console.log("I am the blob type............")
  console.log(base64Data)
  console.log(blob.type)
  sendEventToFlutter(
    "download",
    { isBefore },
    { member_id, file_name: fileName, file_base64: base64Data, mime_type: blob.type }
  );
//   downloadBlobLocally(blob, fileName);

}

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(",")[1]); // strip data:...;base64,
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function uploadSvgAsImageToS3(svgElement, member_id, redirect_url="https://memyfolks.com/", family_name,source="app",is_paid,bounding,language,fit_tree,coordinates={width:0,height:0},isBefore,exportType) {
	if (svgElement) {
	const svgElementClone = removeCardAddPathElements(svgElement,language);
	
		//  Add the pattern definition to the SVG (for the image-based frame)
		// 	// Create the frame image element
		// 	const frameImage = document.createElementNS("http://www.w3.org/2000/svg", "image");
		// 	frameImage.setAttribute("href", frameBase64);  // Base64 encoded image for the frame
		// 	frameImage.setAttribute('width', bounding.width);  // Adjust based on the frame size
		// 	frameImage.setAttribute('height', bounding.height);

		// 	// Insert the frame image before the content
		// 	svgElementClone.appendChild(frameImage);
	let bg_background_coordinate={'width':0,'height':0}
	if(!fit_tree)
	{	
		svgElementClone.setAttribute('width', coordinates.width);
   		svgElementClone.setAttribute('height', coordinates.height); 
    	svgElementClone.setAttribute('viewBox', `0 0 ${coordinates.width+1000} ${coordinates.height+1000}`);
		bg_background_coordinate.width=coordinates.width+1000
		bg_background_coordinate.height=coordinates.height+1000

	}
	else
	{
		svgElementClone.setAttribute('width', bounding.width);
		svgElementClone.setAttribute('height', bounding.height);
		svgElementClone.setAttribute('viewBox', '0 0 1535 694');
		bg_background_coordinate.width=1535
		bg_background_coordinate.height=694
	}
	if(language.bg_color && !language.bg_image){
		const backgroundRect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
		backgroundRect.setAttribute('width', bg_background_coordinate.width);
		backgroundRect.setAttribute('height', bg_background_coordinate.height);
		backgroundRect.setAttribute('fill', language.bg_color);  // Set background color

		// Insert the rect at the beginning of the SVG
		svgElementClone.insertBefore(backgroundRect, svgElementClone.firstChild);
	}
    svgElementClone.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    const svgNS = "http://www.w3.org/2000/svg";
    
    const logoSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" x="10" y="10" height="100" width="100" viewBox="0 0 100 100">
      <?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 26.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 612 180.26" style="enable-background:new 0 0 612 180.26;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#D2DEEA;}
	.st1{fill:#5E9BC1;}
	.st2{fill:#85AECD;}
	.st3{fill:#ABC5DB;}
	.st4{fill:#06749C;}
	.st5{fill:#154C5E;}
</style>
<g>
	<g>
		<circle class="st0" cx="90.11" cy="13.67" r="9.35"/>
		<circle class="st1" cx="89.96" cy="49.45" r="14.33"/>
		<circle class="st2" cx="60.55" cy="38.88" r="8.72"/>
		<circle class="st3" cx="62.68" cy="15.66" r="6.23"/>
		<circle class="st4" cx="148.36" cy="62.28" r="8.1"/>
		<circle class="st4" cx="104.78" cy="109.48" r="7.79"/>
		<circle class="st4" cx="76.26" cy="77.4" r="9.35"/>
		<circle class="st4" cx="27.74" cy="80.22" r="9.35"/>
		<circle class="st3" cx="113.64" cy="14.82" r="6.23"/>
		<circle class="st2" cx="120.63" cy="38.49" r="9.66"/>
		<circle class="st1" cx="135.89" cy="24.45" r="5.61"/>
		<circle class="st1" cx="42.19" cy="24.94" r="4.67"/>
		<circle class="st1" cx="30.99" cy="46.07" r="11.22"/>
		<path class="st4" d="M112.19,150.45c0.2,1.39,0.21,2.82,0.02,4.3c-0.77,5.75-5.26,10.48-10.49,12.96
			c-9.15,4.34-20.95,2.66-27.8-4.99c-5.99-6.68-7.91-16.28-7.61-25.02c0.1-2.78,0.42-5.55,1.02-8.27
			c3.23-14.82,13.55-27.23,26.14-35.14c4.15-2.61,8.55-4.79,12.63-7.51c1.74-1.16,3.48-2.48,4.44-4.35
			c0.96-1.87,0.92-4.41-0.62-5.83c-1.66-1.53-4.27-1.22-6.38-0.44c-9.35,3.44-14.77,13.15-24.67,15.57
			c-2.94,0.72-6.16,0.7-8.88-0.64c-3.56-1.76-5.77-5.57-6.61-9.47c-1.23-5.73,0.31-11.52-0.88-17.26c-0.35-1.67-0.93-3.35-2.11-4.57
			s-3.05-1.88-4.62-1.25c-2.06,0.84-2.79,3.43-2.71,5.67c0.08,2.19,0.15,4.36,0.21,6.53c0.59,24.13-5.78,48.2,2.52,71.66
			c3.46,9.79,8.23,19.52,17.44,25.04c9.14,5.48,20.92,6.69,30.89,2.8c9.52-3.71,15.86-12.09,18.89-21.65
			c2.03-6.41,2.71-13.15,2.99-19.84c0.28-6.59,0.58-13.12,0.27-19.72c-0.17-3.5-0.46-6.99-0.9-10.47c-0.3-2.42-0.17-6.88-2.88-8.08
			c-3.85-1.7-5.14,4.03-5.21,6.64c-0.14,5.64,1.4,11.26,0.55,16.9c-0.4,2.68-1.44,5.41-3.57,7.09c-4.78,3.76-11.93,1.91-16.73-0.67
			c-3.96-2.12-7.45-5.3-11.71-6.78c-0.8-0.28-1.66-0.49-2.5-0.36c-0.84,0.14-1.66,0.7-1.88,1.52c-0.19,0.7,0.08,1.43,0.39,2.09
			c2.66,5.59,8.84,8.7,13.6,12.22C102.2,134.18,110.92,141.47,112.19,150.45z"/>
		<path class="st4" d="M174.22,87.57c-0.09-8.02-1.31-16.02-3.61-23.73c-1.88-6.29-4.46-12.61-8.45-17.89
			c-2.82-3.74-5.53-8.14-9.46-10.81c-5.67-3.84-9.26,1.07-5.22,6.56c3.04,4.14,6.97,7.54,10.13,11.58
			c3.17,4.04,5.62,9.08,4.93,14.18c-0.27,2-1.04,3.97-2.37,5.48c-2.73,3.1-7.4,3.83-11.4,2.86c-10.38-2.5-16.22-11.66-23.54-18.55
			c-1.03-0.97-2.14-1.92-3.48-2.39c-2.19-0.77-4.63,0.26-5.38,2.53c-1.5,4.5,4,8.45,6.81,11.11c9.18,8.73,17.94,18.42,22.59,30.25
			c6.72,17.1,4.04,38-8.51,51.67c-12.31,13.4-29.56,20.22-47.57,20.22c-10.85,0-21.69-2.33-31.32-7.45
			c-15.91-8.45-31.31-25.76-28.79-44.99c0.89-6.78,3.84-13.41,8.88-18.12c2.32-2.17,5.24-3.69,7.66-5.78
			c1.29-1.12,2.63-2.65,2.22-4.3c-0.38-1.52-2.17-2.32-3.73-2.16s-2.94,1.02-4.3,1.8c-2.45,1.4-5.02,2.61-7.66,3.6
			c-3.29,1.23-6.9,2.13-10.28,1.19c-3.88-1.09-6.81-4.55-7.93-8.42c-1.12-3.87-0.63-8.06,0.66-11.87c1.29-3.82,3.33-7.32,5.35-10.8
			c0.78-1.34,1.58-2.97,0.9-4.37c-0.63-1.3-2.37-1.76-3.76-1.34c-1.39,0.41-2.47,1.48-3.41,2.59c-5.97,7.04-7.91,16.67-8.13,25.9
			c-0.02,0.79-0.02,1.58-0.02,2.38C6.01,88.47,6,88.45,6,88.45c0,46.46,37.67,84.13,84.13,84.13c12.2,0,24.34-2.65,35.41-7.79
			c10.73-4.98,20.36-12.25,28.12-21.18c7.81-8.98,13.68-19.61,17.09-31.02C173.17,104.47,174.32,96.01,174.22,87.57z"/>
	</g>
	<g>
		<path class="st5" d="M249.56,82.78h-0.34l-12.7,25.4h-5.46l-12.7-25.4h-0.34v35.2h-10.14V58.31h8.27l17.47,34.35h0.34l17.56-34.35
			h8.18v59.67h-10.14L249.56,82.78L249.56,82.78z"/>
		<path class="st5" d="M270.29,88.4c0-11.25,5.8-18.24,17.9-18.24c12.36,0,17.65,6.73,17.65,18.24v9.72h-25.32v4.6
			c0,3.58,2.21,7.08,8.44,7.08c5.37,0,8.01-1.19,12.45-3.58l3.41,7.59c-4.77,2.73-9.12,4.86-16.28,4.86
			c-12.19,0-18.24-6.39-18.24-16.88V88.4H270.29z M280.52,90.11h15.34c0-7.42-1.45-11.08-7.67-11.08
			C282.05,79.03,280.52,82.26,280.52,90.11z"/>
		<path class="st5" d="M357.66,82.78h-0.34l-12.7,25.4h-5.46l-12.7-25.4h-0.34v35.2h-10.14V58.31h8.27l17.47,34.35h0.34l17.56-34.35
			h8.18v59.67h-10.14L357.66,82.78L357.66,82.78z"/>
		<path class="st5" d="M395.86,135.2h-9.72l5.54-17.22h-1.87L376,70.84h10.65l8.78,33.84h0.34l9.29-33.84h10.74L395.86,135.2z"/>
		<path class="st5" d="M434.48,117.98h-10.74V58.31h33.33v9.38h-22.59v16.37h20.63v9.38h-20.63V117.98z"/>
		<path class="st5" d="M465.25,100.51V88.57c0-11.34,5.88-18.41,18.33-18.41c12.53,0,18.33,6.99,18.33,18.41v11.93
			c0,11.34-5.8,18.16-18.33,18.16C471.14,118.66,465.25,111.67,465.25,100.51z M475.48,89v10.91c0,6.56,2.05,9.72,8.1,9.72
			c6.05,0,8.1-3.15,8.1-9.72V89c0-6.65-2.05-9.72-8.1-9.72S475.48,82.35,475.48,89z"/>
		<path class="st5" d="M511.46,54.05h10.23v63.93h-10.23V54.05z"/>
		<path class="st5" d="M532.77,54.05H543V88.4h3.92l10.49-17.56h10.91l-13.04,21.4l13.38,25.74h-11.08c0,0-3.32-6.65-10.4-20.97H543
			v20.97h-10.23V54.05z"/>
		<path class="st5" d="M572.5,114.14l2.9-7.5c5.71,2.47,9.97,3.41,13.47,3.41c4.94,0,7.16-2.05,7.16-6.05
			c0-8.78-22.42-4.18-22.42-20.2c0-9.38,6.9-13.64,16.28-13.64c5.71,0,10.91,1.62,15,4.18l-3.07,7.59
			c-5.2-2.39-8.69-3.15-11.51-3.15c-4.09,0-6.82,1.19-6.82,4.69c0,7.59,22.5,4.09,22.5,19.69c0,10.06-5.11,15.51-17.13,15.51
			C583.16,118.66,576.51,116.62,572.5,114.14z"/>
	</g>
</g>
</svg>
    </svg>
    `;
    if(!is_paid){
			if (exportType!= "html"){
				// Create a container to hold the inlined SVG
				const logoContainer = document.createElementNS(svgNS, 'g');
				logoContainer.innerHTML = logoSVG;
				svgElementClone.appendChild(logoContainer);
			}
			// Define the watermark pattern
			const defs = document.createElementNS(svgNS, 'defs');
			const pattern = document.createElementNS(svgNS, 'pattern');
			pattern.setAttribute('id', 'watermark-pattern');
			pattern.setAttribute('patternUnits', 'userSpaceOnUse');
			pattern.setAttribute('width', '300');  // Horizontal spacing of watermark text
			pattern.setAttribute('height', '50'); // Vertical spacing of watermark tex
			// Create a text element inside the pattern
			const watermarkText = document.createElementNS(svgNS, 'text');
			watermarkText.setAttribute('x', '100');  // Adjust horizontal position of watermark text
			watermarkText.setAttribute('y', '25');  // Adjust vertical position of watermark text
			watermarkText.setAttribute('fill', 'rgba(0, 0, 0, 0.1)');  // Set the watermark color
			// watermarkText.setAttribute('opacity', '0.4');  // Make it subtle
			watermarkText.setAttribute('font-size', '16');  // Adjust font size
			// watermarkText.setAttribute('font-family', 'Arial');  // Font family for the watermark
			watermarkText.textContent = "memyfolks.com";  // Your watermark text

			// Append the text to the pattern
			pattern.appendChild(watermarkText);
		// setWatermarkText()
			// Add the pattern to defs
			defs.appendChild(pattern);
			svgElementClone.appendChild(defs);

			// Apply the pattern as a background
			const rect = document.createElementNS(svgNS, 'rect');
			rect.setAttribute('width', '100%');
			rect.setAttribute('height', '100%');
			rect.setAttribute('fill', 'url(#watermark-pattern)');  // Use the pattern as fill
			svgElementClone.appendChild(rect);

		}
		else{
			if (exportType!= "html"){
			const logoContainer = document.createElementNS(svgNS, 'g');
			logoContainer.innerHTML = logoSVG;
			svgElementClone.appendChild(logoContainer);
			}
			const image = svgElementClone.querySelector('.background_image');
			// console.log("I am the one..........................")
			// console.log(image)
			if (image && image.hasAttribute('href')) {
				// Get the URL from the href attribute
				const imageUrl = image.getAttribute('href');
				if(imageUrl && imageUrl !== null && imageUrl !== undefined && imageUrl !== "null" && imageUrl !== "undefined"){
				// Convert the image URL to base64 and update the href
				const base64String = await convertImageToBase64(imageUrl);
				image.setAttribute('href', base64String);
				image.setAttribute('width', bounding.width);  // Change to the desired width
  				image.setAttribute('height', bounding.height); 
				// console.log(image)
					}
			  } else {
				console.log('Image element not found or no href attribute.');
			  }
			 
		}
    if (family_name!='Enter family name!'){
        // Add family name text in the top-middle
        const text = document.createElementNS(svgNS, 'text');
		if(!fit_tree)
		{
        	text.setAttribute('x', (coordinates.width)/2); // Position it horizontally in the middle
			text.setAttribute('font-size', '35');  // Adjust the font size

		}
		else{
			text.setAttribute('x', bounding.width/2); // Position it horizontally in the middle
			text.setAttribute('font-size', '22');  // Adjust the font size

		}
		// Determine the width of the element dynamically, either from coordinates or bounding box
		const middleX = fit_tree ? (bounding.width / 2) : ((coordinates.width+500) / 2);
		// Set the x-coordinate to align the text horizontally in the middle of the page
		text.setAttribute('x', middleX);
		text.setAttribute('text-anchor', 'middle');
        text.setAttribute('y', '38');  // Adjust the y position as needed
        text.setAttribute('font-family',language.value);  // Set the font
        text.setAttribute('font-style', 'italic'); 
        text.setAttribute('fill', 'black');  // Set the text color
        text.setAttribute('style', 'text-decoration: underline;');
        text.textContent = family_name;  // Replace with the actual family name
        svgElementClone.appendChild(text);
        // Convert the SVG element to a string
      }
	  await new Promise(resolve => setTimeout(resolve, 2000));

    // const svgData = svgElementClone.outerHTML;
	let svgData;
	if (exportType === "html") {
    const serializer = new XMLSerializer();
    svgData = serializer.serializeToString(svgElementClone);
	}
 	else {
		svgData = svgElementClone.outerHTML;
	}

		await axiosInstance.post(`${API_BASE_URL}convert-svg-to-pdf/`, { svg_data: svgData,member_id:member_id,is_paid:is_paid,font_family_id:language && language.id?language.id:"",coordinates:coordinates,fit_tree:fit_tree,upload_type:exportType}, {
			headers: {
			  'Content-Type': 'application/json',
			}    })
		  .then(response => {
			if(response.data && response.data.data){
			  if(source=='website'){
				  window.open(response.data.data.oci_url, '_blank');
			  }
			  else{
					// redirect_url.searchParams.append('file_name', response.data.data.file_name);
					// callFlutterHandler('communicationname',{"file_name":response.data.data.file_name,"member_id":member_id,"event":'download'})
					// if(isBefore){
					// 	window.location.href = redirect_url.href;
					// }
					handleExport(svgElementClone, exportType, coordinates, fit_tree,isBefore,member_id,response.data.data.file_name)
					//sendEventToFlutter("download", {isBefore:isBefore}, { member_id: member_id, file_name: response.data.data.file_name });
				  }
			}
		  
		  })
		  .catch(error => {
			console.error('Error sending SVG:', error);
		  });
    
  } else {
    console.error('SVG element not found');
  }
  
}
